module.exports = __webpack_public_path__ + "img/img_17@2x.ad4cd771.png";